module.exports = __webpack_public_path__ + "img/recruitment.a198c34c.png";